import request from '@/utils/request';
import { BASE_API, MOCK_API } from '@/utils/consts'


//漏斗图分析
export function getCustomerByFunnel(data) {
  return request(`${BASE_API}/clinic/customer-analysis/graph/funnel`, {
    method: 'POST',
    data
  });
}

//升单情况
export function getUpgradeOrder(data){
  return request(`${BASE_API}/clinic/customer-analysis/list/upgrade-order`, {
    method: 'POST',
    data
  });
}

//消耗情况
export function getConsumption(data){
  return request(`${BASE_API}/clinic/customer-analysis/list/consumption`, {
    method: 'POST',
    data
  });
}

//项目分析 成交情况
export function getDealInfo(data){
  return request(`${BASE_API}/project/analysis/deal`, {
    method: 'POST',
    data
  });
}

//项目分析 升单
export function getUpInProject(data){
  return request(`${BASE_API}/project/analysis/upgrade_order`, {
    method: 'POST',
    data
  });
}

//项目分析 消耗
export function getConsumInProject(data){
  return request(`${BASE_API}/project/analysis/reservation_item`, {
    method: 'POST',
    data
  });
}

//项目分析 收入
export function getIncomeInProject(data){
  return request(`${BASE_API}/project/analysis/income`, {
    method: 'POST',
    data
  });
}

// 渠道分析 建档到店
export function getRecordInChannel(data){
  return request(`${BASE_API}/channel/analysis/customer`, {
    method: 'POST',
    data
  });
}

//渠道分析 升单
export function getUpInChannel(data){
  return request(`${BASE_API}/channel/analysis/upgrade_order`, {
    method: 'POST',
    data
  });
}

//渠道分析 收款
export function getCollectionInChannel(data){
  return request(`${BASE_API}/channel/analysis/payment`, {
    method: 'POST',
    data
  });
}

//渠道分析 消耗
export function getConsumeInChannel(data){
  return request(`${BASE_API}/channel/analysis/reservation_item`, {
    method: 'POST',
    data
  });
}

//退款分析 人员分析
export function getPeopleInRefund(data){
  return request(`${BASE_API}/refund/analysis/employee`, {
    method: 'POST',
    data
  });
}

//退款分析 渠道退款
export function getChannelInRefund(data){
  return request(`${BASE_API}/refund/analysis/channel`, {
    method: 'POST',
    data
  });
}

//退款分析 项目退款
export function getProjectInRefund(data){
  return request(`${BASE_API}/refund/analysis/reservation_item`, {
    method: 'POST',
    data
  });
}

//升单排名 按渠道
export function getUpInRankByChannel(data){
  return request(`${BASE_API}/rank/upgrade-order/channel`, {
    method: 'POST',
    data
  });
}

//升单排名 按人
export function getUpInRankByPeople(data){
  return request(`${BASE_API}/rank/upgrade-order/consultant`, {
    method: 'POST',
    data
  });
}

//消耗排名（按渠道）
export function getConsumeInRankByChannel(data){
  return request(`${BASE_API}/rank/consumption/channel`, {
    method: 'POST',
    data
  });
}

//消耗排名（按人）
export function getConsumeInRankByPeople(data){
  return request(`${BASE_API}/rank/consumption/consultant`, {
    method: 'POST',
    data
  });
}

//消耗次数排名
export function getCountInRank(data){
  return request(`${BASE_API}/rank/consumption/times`, {
    method: 'POST',
    data
  });
}

//成交排名  按人
export function getConsultantInRankByPerson(data){
  return request(`${BASE_API}/statistics/operation/platform/consultant/person`, {
    method: 'POST',
    data
  });
}

//周月报表 DPP消耗分析
export function getDPPAnalysis(data){
  return request(`${BASE_API}/dpp/analysis/consumption`, {
    method: 'POST',
    data
  });
}

//周月报表 整体情况
export function getAllAnalysis(data){
  return request(`${BASE_API}/report/overall`, {
    method: 'POST',
    data
  });
}

//建档-到店趋势图
export function getRecordForChart(data){
  return request(`${BASE_API}/tendency-chart/document-arrive`, {
    method: 'POST',
    data
  });
}

//成交-升单趋势图
export function getUpForChart(data){
  return request(`${BASE_API}/tendency-chart/deal-upgrade`, {
    method: 'POST',
    data
  });
}

//收款-升单趋势图
export function getCollectionForChart(data){
  return request(`${BASE_API}/tendency-chart/payment-upgrade`, {
    method: 'POST',
    data
  });
}

//收入-消耗趋势图
export function getIncomeForChart(data){
  return request(`${BASE_API}/tendency-chart/income-consumption`, {
    method: 'POST',
    data
  });
}


// 诊所商品列表

export async function queryClinicProduct(data) {  
  return request(`${BASE_API}/product/list`, {
    method: 'POST',
    data
  });
}



// 原始数据统计 客户数据-分页列表 建档
export function queryCustomerList(data){
  return request(`${BASE_API}/statistics/basic/customer`, {
    method: 'POST',
    data
  });
}

//原始数据统计 客户数据-分页列表 建档 客户数据-导出
export function exportCustomer(data){
  return request(`${BASE_API}/statistics/basic/customer/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

// 原始数据统计 到店数据-分页列表
export function queryArriveList(data){
  return request(`${BASE_API}/statistics/basic/reservation-arrived`, {
    method: 'POST',
    data
  });
}

//原始数据统计 到店数据-导出
export function exportArrive(data){
  return request(`${BASE_API}/statistics/basic/reservation-arrived/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

// 原始数据统计 订单数据-分页列表
export function queryOrderList(data){
  return request(`${BASE_API}/statistics/basic/order`, {
    method: 'POST',
    data
  });
}

//原始数据统计 订单数据-导出
export function exportOrder(data){
  return request(`${BASE_API}/statistics/basic/order/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

// 原始数据统计 订单数据-分页列表
export function queryCollectionList(data){
  return request(`${BASE_API}/statistics/basic/payment`, {
    method: 'POST',
    data
  });
}

//原始数据统计 订单数据-导出
export function exportCollection(data){
  return request(`${BASE_API}/statistics/basic/payment/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

// 原始数据统计 退款数据-分页列表
export function queryRefundList(data){
  return request(`${BASE_API}/statistics/basic/refund`, {
    method: 'POST',
    data
  });
}

//原始数据统计 退款数据-导出
export function exportRefund(data){
  return request(`${BASE_API}/statistics/basic/refund/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

// 原始数据统计 消耗数据-分页列表
export function queryConsumeList(data){
  return request(`${BASE_API}/statistics/basic/reservation-finished`, {
    method: 'POST',
    data
  });
}

//原始数据统计 消耗数据-导出
export function exportConsume(data){
  return request(`${BASE_API}/statistics/basic/reservation-finished/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

//月报统计 云诊所整体KPI
export function queryKpiMonth(data){
  return request(`${BASE_API}/statistics/monthly/kpi/clinic`, {
    method: 'POST',
    data,
  }); 
}

//月报统计 建档
export function queryRecordMonth(data){
  return request(`${BASE_API}/statistics/monthly/customer`, {
    method: 'POST',
    data,
  }); 
}

//月报统计 首次到店
export function queryFirstMonth(data){
  return request(`${BASE_API}/statistics/monthly/reservation-first-arrived`, {
    method: 'POST',
    data,
  }); 
}

//月报统计 成交
export function queryDealMonth(data){
  return request(`${BASE_API}/statistics/monthly/done`, {
    method: 'POST',
    data,
  }); 
}

//月报统计 服务
export function queryServiceMonth(data){
  return request(`${BASE_API}/statistics/monthly/services`, {
    method: 'POST',
    data,
  }); 
}

//月报统计 分类消耗
export function queryClassMonth(data){
  return request(`${BASE_API}/statistics/monthly/performance-finished`, {
    method: 'POST',
    data,
  }); 
}


//月报统计 渠道消耗
export function queryChannelMonth(data){
  return request(`${BASE_API}/statistics/monthly/reservation-finished`, {
    method: 'POST',
    data,
  }); 
}

//周报统计 Kpi
export function queryKpiWeek(data){
  return request(`${BASE_API}/statistics/weekly/kpi/clinic`, {
    method: 'POST',
    data,
  }); 
}


//周报统计 建档
export function queryRecordWeek(data){
  return request(`${BASE_API}/statistics/weekly/customer`, {
    method: 'POST',
    data,
  }); 
}

//周报统计 首次到店
export function queryFirstWeek(data){
  return request(`${BASE_API}/statistics/weekly/reservation-first-arrived`, {
    method: 'POST',
    data,
  }); 
}

//周报统计 成交
export function queryDealWeek(data){
  return request(`${BASE_API}/statistics/weekly/done`, {
    method: 'POST',
    data,
  }); 
}

//周报统计 服务
export function queryServiceWeek(data){
  return request(`${BASE_API}/statistics/weekly/services`, {
    method: 'POST',
    data,
  }); 
}

//周报统计 分类消耗
export function queryClassWeek(data){
  return request(`${BASE_API}/statistics/weekly/performance-finished`, {
    method: 'POST',
    data,
  }); 
}


//周报统计 渠道消耗
export function queryChannelWeek(data){
  return request(`${BASE_API}/statistics/weekly/reservation-finished`, {
    method: 'POST',
    data,
  }); 
}

//月报KPI-导出
export function exportMonthKpi(data){
  return request(`${BASE_API}/statistics/monthly/kpi/clinic/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

//周报KPI-导出
export function exportWeekKpi(data){
  return request(`${BASE_API}/statistics/weekly/kpi/clinic/export`, {
    method: 'GET',
    data,
    responseType:'blob',download:true
  }); 
}

//成交排名 按渠道
export function dealRankByChannel(data){
  return request(`${BASE_API}/statistics/operation/clinic/consultant/channelCategory`, {
    method: 'POST',
    data,
  }); 
}

//成交排名 按人
export function dealRankByPerson(data){
  return request(`${BASE_API}/statistics/operation/clinic/consultant/person`, {
    method: 'POST',
    data,
  }); 
}

//成交排名-按渠道-导出
export function exportDealRankByChannel(data){
  return request(`${BASE_API}/statistics/operation/export/clinic/consultant/channelCategory`, {
    method: 'POST',
    data,
    responseType:'blob',download:true
  }); 
}

//成交排名-按人-导出
export function exportDealRankByPerson(data){
  return request(`${BASE_API}/statistics/operation/export/clinic/consultant/person`, {
    method: 'POST',
    data,
    responseType:'blob',
    download:true
  }); 
}

//消耗排名-按人
export function getConsumeInRankByPerson(data){
  return request(`${BASE_API}/statistics/operation/clinic/psychologist/person`, {
    method: 'POST',
    data,
  }); 
}

//消耗排名-渠道
export function queryConsumeInRankByChannel(data){
  return request(`${BASE_API}/statistics/operation/clinic/psychologist/channelCategory`, {
    method: 'POST',
    data,
  }); 
}

//查询岗位设置列表
export function getJobPostion(data) {
  return request(`${BASE_API}/job_position/all`, {
    method: 'POST',
    data
  });
}

//消耗排名 导出 渠道
export function exportConsumeRankByChannel(data){
  return request(`${BASE_API}/statistics/operation/export/clinic/psychologist/channelCategory`, {
    method: 'POST',
    data,
    responseType:'blob',download:true
  }); 
}

//消耗排名 导出 按人
export function exportConsumeRankByPerson(data){
  return request(`${BASE_API}/statistics/operation/export/clinic/psychologist/person`, {
    method: 'POST',
    data,
    responseType:'blob',download:true
  }); 
}